import type { StepTask } from '../../types'
import { Field, ReadonlyValue, SectionHeader, getParams } from './fields'
import { FraudProposedConfig } from './FraudProposedConfig'

export interface FraudDrawerProps {
  task: StepTask
  onChange: (updater: (t: StepTask) => StepTask) => void
}

export function FraudDrawer({ task }: FraudDrawerProps) {
  const params = getParams(task)
  const provider = (params.providerName as string | undefined) ?? ''

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Existing ops center workflow config" />

      <Field label="Provider Name">
        <ReadonlyValue>{provider || '—'}</ReadonlyValue>
      </Field>

      <SectionHeader title="Proposed additional config" hint="Mockup · not saved" />
      <p className="text-[10px] text-[#5b6b85] -mt-2">
        Grouped by the v2 config file each setting lives in.
      </p>

      <FraudProposedConfig />
    </div>
  )
}
